/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AssignmentPeerFeedbackSettings } from './AssignmentPeerFeedbackSettings';
import { Enabled } from './Enabled';
const EnabledPeerFeedbackParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['settings', AssignmentPeerFeedbackSettings],
]), Enabled);
export class EnabledPeerFeedback extends Enabled {
    static decode(input) {
        return EnabledPeerFeedbackParser.decode(input).map(res => new EnabledPeerFeedback(res));
    }
    static unsafeDecode(input) {
        return EnabledPeerFeedback.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledPeerFeedbackParser.encode(data);
    }
    static schema() {
        return EnabledPeerFeedbackParser.schema();
    }
}
